// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2hkZ5","info":"PatientInfo_info__1_NiI"};